import React, { Component } from 'react';
import { FormikValues } from 'formik';

import { IWithUser, withUser } from 'providers';
import { getUrl, getPhoto } from 'features/content/helpers';

import { Content, PreviewUrlComponent } from 'api';
import { RemoveTypes } from '../types';
import { Photo as PhotoPreview, Url as UrlPreview } from './PreviewPartials';

interface IProps extends IWithUser {
  content: FormikValues | Content;
  onRemove?: (type: RemoveTypes) => () => void;
}

interface IState {
  removedPreview: boolean;
}

class Preview extends Component<IProps, IState> {
  isSavedUrl() {
    const { content } = this.props;
    return !!content.content_object.url_metadata;
  }

  renderPhotoPreview() {
    const { content, onRemove } = this.props;
    const photo = getPhoto(content);

    return <PhotoPreview photo={photo} onRemove={onRemove} />;
  }

  renderSavedUrlPreview() {
    const { content, onRemove } = this.props;

    return <UrlPreview onRemove={onRemove} values={content} />;
  }

  renderCachedUrlPreview() {
    const { content, user, onRemove } = this.props;

    const url = getUrl(content);
    const variables = {
      url,
      user_id: user.id,
      client_id: user.client_id,
    };

    return (
      <PreviewUrlComponent variables={variables}>
        {(mutation, options) => (
          <UrlPreview mutate={mutation} mutateOptions={options} onRemove={onRemove} />
        )}
      </PreviewUrlComponent>
    );
  }

  render() {
    const { content } = this.props;

    if (getPhoto(content)) {
      return this.renderPhotoPreview();
    }

    if (getUrl(content)) {
      return this.isSavedUrl() ? this.renderSavedUrlPreview() : this.renderCachedUrlPreview();
    }

    return null;
  }
}

export default withUser(Preview);
